import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { DISCOVERY_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API discovery / entry-flow сотрудника EyeHub (Ц2 / Ц12).
 *
 * - getDiscovery: публичный (до логина) поиск организации по рабочему email.
 *   GET auth/discovery/?email= → {organization:{slug,name}|null, sites:[{name, entryUrl}]}.
 *   Ответ уже развёрнут из unified-envelope ({data} → тело).
 *
 * - getMySites: площадки текущего (залогиненного) пользователя с флагами
 *   маршрутизации. GET my-sites/. Эндпоинт добавляется backend-агентом
 *   (FIX_MANIFEST A3); если он ещё не задеплоен — вернётся 404, и страница
 *   site-picker деградирует на discovery-данные (см. pages/MySites).
 */
export const discoveryApi = createApi({
  reducerPath: "discoveryApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["MySites"],
  endpoints: (builder) => ({
    getDiscovery: builder.query({
      query: ({ email } = {}) => ({
        url: DISCOVERY_ENDPOINTS.DISCOVER,
        method: "GET",
        params: { email },
      }),
    }),

    getMySites: builder.query({
      query: () => ({ url: DISCOVERY_ENDPOINTS.MY_SITES, method: "GET" }),
      providesTags: [{ type: "MySites", id: "LIST" }],
    }),
  }),
});

export const {
  useGetDiscoveryQuery,
  useLazyGetDiscoveryQuery,
  useGetMySitesQuery,
} = discoveryApi;

export default discoveryApi;
